import React from "react";
import { Helmet } from "react-helmet-async";

const pageUrl = "https://missionmovement.nl/legal";

const sections = [
  {
    id: "legal",
    heading: "Legal",
    paragraphs: [
      "Mission Movement is een voorbereidings- en coachingplatform voor kandidaten richting Defensie en veiligheidsdiensten. Mission Movement is een in Nederland ingeschreven onderneming, eigendom van Justin Peeters, en staat ingeschreven onder KVK 85486205. De website is https://missionmovement.nl.",
      "Mission Movement is onafhankelijk en is niet officieel verbonden aan Defensie, politie, brandweer, KMar of andere overheidsorganisaties. Contact verloopt via mission.movement@outlook.com.",
      "Deze pagina geeft praktische informatie over vertrouwen, betalingen, privacy en voorwaarden. Zij is bedoeld als duidelijke toelichting voor klanten en vormt geen formeel juridisch advies.",
    ],
  },
  {
    id: "payment",
    heading: "Betaling",
    paragraphs: [
      "Betalingen worden verwerkt via Stripe. Mission Movement ontvangt niet jouw volledige kaart- of betaalgegevens; Stripe verwerkt de betaling via zijn beveiligde betaalomgeving.",
      "Na een succesvolle betaling ontvang je per e-mail een bevestiging en de volgende stappen. Afhankelijk van het product kan dit digitale toegang, downloadlinks, intake-instructies, movement-assessment-instructies of verdere coachingopvolging bevatten.",
      "De prijzen die tijdens checkout worden getoond, zijn leidend op het moment van aankoop.",
    ],
  },
  {
    id: "delivery",
    heading: "Levering digitale inhoud & coaching",
    paragraphs: [
      "Bij digitale producten kan levering direct na aankoop starten via e-mail, downloadlink, accounttoegang of andere online toegang. Controleer daarom bij aankoop zorgvuldig je e-mailadres en spammap.",
      "Bij begeleide trajecten bestaat de levering uit een combinatie van digitale voorbereiding en persoonlijke dienstverlening, zoals intake, assessment, persoonlijke analyse, programma-opbouw en coachingopvolging. De precieze vervolgstappen worden na betaling per e-mail bevestigd.",
    ],
  },
  {
    id: "terms-conditions",
    heading: "Algemene voorwaarden",
    paragraphs: [
      "Deze voorwaarden gelden voor aankopen, digitale programma's, voorbereidingsmaterialen, coaching en contactdiensten van Mission Movement. Door een aankoop te doen, ga je akkoord met de relevante voorwaarden die op deze pagina en tijdens checkout worden getoond.",
      "Je bent verantwoordelijk voor het juist aanleveren van gegevens die nodig zijn voor levering, intake, begeleiding en contact. Misbruik van formulieren, systemen, digitale toegang of materialen kan leiden tot beperking van toegang.",
    ],
  },
  {
    id: "checkout-conditions",
    heading: "Checkoutvoorwaarden",
    paragraphs: [
      "Voor het starten van checkout moet je actief akkoord gaan met de voorwaarden, privacy-informatie en checkoutvoorwaarden. De knop naar betaling geeft duidelijk aan dat je een bestelling met betalingsverplichting plaatst.",
      "Wanneer je kiest voor directe digitale levering, directe toegang of voorbereiding die direct na aankoop start, bevestig je dat levering binnen de bedenktijd kan beginnen en dat dit gevolgen kan hebben voor het herroepingsrecht voor digitale inhoud.",
    ],
  },
  {
    id: "withdrawal-right",
    heading: "Herroepingsrecht, digitale inhoud & refunds",
    paragraphs: [
      "Consumenten hebben bij online aankopen meestal 14 dagen herroepingsrecht. Voor digitale producten, downloads en online materialen kan het herroepingsrecht voor dat digitale deel vervallen zodra digitale inhoud of toegang direct na aankoop wordt geleverd, als je daar vooraf uitdrukkelijk mee instemt en bevestigt dat je dit gevolg begrijpt.",
      "Bij begeleide coaching kan terugbetaling of herroeping afhangen van de vraag of intake, assessment, persoonlijke analyse, digitale materialen, coachingvoorbereiding of toegang al is gestart.",
      "Als nog geen digitale materialen, toegang, coaching, intake of persoonlijke voorbereiding is gestart, kan terugbetaling binnen 14 dagen na je verzoek mogelijk zijn. Zodra digitale toegang, intake, assessment, persoonlijke voorbereiding of coaching is gestart, kan een volledige terugbetaling beperkt of niet meer beschikbaar zijn.",
      "Er worden geen refunds gegeven enkel omdat je niet wordt geselecteerd, niet slaagt voor een test of training, niet wordt aangenomen, geen medische of psychologische goedkeuring krijgt of een persoonlijk doel niet behaalt.",
      "Stuur refundverzoeken naar mission.movement@outlook.com met je naam, aankoopdatum, product en het e-mailadres waarmee je hebt betaald.",
    ],
  },
  {
    id: "no-guarantee",
    heading: "Geen garantie op selectie of toelating",
    paragraphs: [
      "Mission Movement helpt met voorbereiding, structuur en begeleiding. Er wordt geen garantie gegeven op selectie, toelating, dienstverband, testresultaat, medische goedkeuring, psychologische goedkeuring of het afronden van een opleiding of training.",
    ],
  },
  {
    id: "health",
    heading: "Gezondheid, training & eigen verantwoordelijkheid",
    paragraphs: [
      "Training brengt risico op overbelasting en blessures met zich mee. Jij bent zelf verantwoordelijk voor de beoordeling of je veilig kunt deelnemen en voor het aanpassen of stoppen van training wanneer dat nodig is.",
      "Raadpleeg een arts of fysiotherapeut bij twijfel, blessures, ziekte, medicatiegebruik of pijnklachten. Deel blessures, beperkingen, trainingsachtergrond, pijnsignalen en andere relevante context eerlijk en volledig.",
      "Mission Movement geeft voorbereiding en coaching, geen medische diagnose of medische behandeling, en garandeert geen blessurevrije voortgang.",
    ],
  },
  {
    id: "cookies",
    heading: "Cookiebeleid",
    paragraphs: [
      "Mission Movement gebruikt noodzakelijke cookies om de website goed te laten werken. Deze cookies ondersteunen basisfunctionaliteit, beveiliging en het onthouden van jouw cookievoorkeuren.",
      "Analyticscookies kunnen worden gebruikt om te begrijpen hoe bezoekers de website gebruiken, welke pagina's worden bekeken en waar de website verbeterd kan worden.",
      "Marketingcookies kunnen worden gebruikt voor advertenties, retargeting en het meten van campagnes wanneer Mission Movement betaalde media inzet.",
      "Analytics- en marketingcookies worden alleen gebruikt met jouw toestemming. Je kunt je voorkeuren later aanpassen via Cookie instellingen in de footer.",
    ],
  },
  {
    id: "intellectual-property",
    heading: "Intellectueel eigendom & persoonlijk gebruik",
    paragraphs: [
      "Materialen van Mission Movement zijn uitsluitend bedoeld voor persoonlijk gebruik door de koper. Content, programma's, documenten, downloadlinks en trainingsmaterialen mogen zonder voorafgaande toestemming niet worden gekopieerd, doorverkocht, opnieuw verspreid, gedeeld, gepubliceerd of commercieel hergebruikt.",
    ],
  },
  {
    id: "privacy",
    heading: "Privacy",
    paragraphs: [
      "Mission Movement kan gegevens verwerken zoals naam, e-mailadres, telefoonnummer of WhatsApp-nummer wanneer je dat verstrekt, berichten, doel of context, trainingsachtergrond, blessure- of belastbaarheidsinformatie die je zelf deelt, aankoop- en betaalmetadata van Stripe en account- of toegangsgegevens wanneer die van toepassing zijn.",
      "Deze gegevens worden gebruikt voor het beantwoorden van berichten, het leveren van digitale producten en coaching, administratie, betalingsverwerking, veiligheid en beveiliging, klantenservice en wettelijke of administratieve verplichtingen.",
      "Voor die doelen kunnen noodzakelijke dienstverleners worden ingezet, zoals de hostingprovider, Firebase/Google, Stripe, de e-mailprovider en, wanneer gebruikt, analytics- of cookietools. Gegevens worden niet verkocht.",
      "Je kunt inzage, correctie of verwijdering aanvragen via mission.movement@outlook.com.",
    ],
  },
];

const Legal = () => {
  return (
    <main className="min-h-screen bg-mmPage text-mmText">
      <Helmet>
        <title>Legal & Vertrouwen | Mission Movement</title>
        <meta
          name="description"
          content="Informatie over privacy, cookies, betalingen, voorwaarden en disclaimer van Mission Movement."
        />
        <meta
          property="og:title"
          content="Legal & Vertrouwen | Mission Movement"
        />
        <meta
          property="og:description"
          content="Informatie over privacy, cookies, betalingen, voorwaarden en disclaimer van Mission Movement."
        />
        <meta property="og:url" content={pageUrl} />
        <link rel="canonical" href={pageUrl} />
      </Helmet>

      <section className="px-5 sm:px-10 lg:px-20 py-16 md:py-20 border-b border-mmBorder">
        <div className="max-w-4xl mx-auto">
          <p className="font-display uppercase tracking-[0.18em] text-mmAccent text-sm md:text-base mb-4">
            Vertrouwen
          </p>
          <h1 className="mm-h1 text-mmText mb-5">Legal & Vertrouwen</h1>
          <p className="text-mmTextMuted text-base md:text-lg leading-relaxed max-w-3xl">
            Informatie over privacy, cookies, betalingen, voorwaarden en de
            onafhankelijke positie van Mission Movement.
          </p>
          <p className="mt-3 text-sm text-mmTextMuted leading-relaxed max-w-3xl">
            Deze pagina geeft praktische informatie over vertrouwen, privacy en
            voorwaarden. Het is geen formeel juridisch advies.
          </p>
        </div>
      </section>

      <section className="px-5 sm:px-10 lg:px-20 py-12 md:py-16">
        <div className="max-w-4xl mx-auto space-y-6">
          {sections.map((section) => (
            <article
              key={section.id}
              id={section.id}
              className="mm-card p-6 md:p-8 scroll-mt-24 md:scroll-mt-28"
            >
              <h2 className="font-display uppercase tracking-widest text-mmAccent text-xl md:text-2xl mb-4">
                {section.heading}
              </h2>
              <div className="space-y-4 text-mmTextMuted text-base md:text-lg leading-relaxed">
                {section.paragraphs.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
              </div>
            </article>
          ))}

          <article className="mm-card p-6 md:p-8">
            <h2 className="font-display uppercase tracking-widest text-mmAccent text-xl md:text-2xl mb-4">
              Contact
            </h2>
            <div className="space-y-2 text-mmTextMuted text-base md:text-lg">
              <p>
                E-mail:{" "}
                <a
                  href="mailto:mission.movement@outlook.com"
                  className="text-mmAccent hover:opacity-80"
                >
                  mission.movement@outlook.com
                </a>
              </p>
              <p>
                WhatsApp:{" "}
                <a
                  href="https://wa.me/31649171684"
                  target="_blank"
                  rel="noreferrer"
                  className="text-mmAccent hover:opacity-80"
                >
                  +31649171684
                </a>
              </p>
            </div>
          </article>
        </div>
      </section>
    </main>
  );
};

export default Legal;
